import * as React from 'react';
import { TeeButton } from '@/components/ui/tee-button';

export interface TeeIconButtonProps {
  icon: React.ReactNode;
  onClick?: () => void;
  disabled?: boolean;
  'aria-label': string;
  className?: string;
}

export const TeeIconButton = React.forwardRef<HTMLButtonElement, TeeIconButtonProps>(
  ({ icon, onClick, disabled, 'aria-label': ariaLabel, className }, ref) => {
    return (
      <TeeButton
        ref={ref}
        variant="ghost"
        size="s"
        onClick={onClick}
        disabled={disabled}
        aria-label={ariaLabel}
        className={className}
      >
        {icon}
      </TeeButton>
    );
  },
);

TeeIconButton.displayName = 'TeeIconButton';
